<button
  type="button"
  class="icon-dd-trigger"
  [class.icon-dd-trigger--disabled]="disabled()"
  [disabled]="disabled()"
  [matMenuTriggerFor]="menu"
  [matTooltip]="alt()"
  [attr.aria-label]="alt()"
  (menuOpened)="menuOpened.emit()"
  (menuClosed)="menuClosed.emit()"
  (click)="$event.stopPropagation()">
  @if (imgSrc()) {
    <img [src]="imgSrc()" [alt]="alt()" class="icon-dd-trigger__img">
  } @else {
    <mat-icon class="icon-dd-trigger__icon material-symbols-outlined">{{ icon() }}</mat-icon>
  }
  <mat-icon class="icon-dd-trigger__arrow">expand_more</mat-icon>
</button>

<mat-menu #menu="matMenu" class="icon-dd-menu">
  <ng-template matMenuContent>
    @for (option of options(); track option.value) {
      <button
        mat-menu-item
        class="icon-dd-item"
        [class.icon-dd-item--active]="activeValue() === option.value"
        [disabled]="option.disabled"
        [attr.aria-current]="activeValue() === option.value ? 'true' : null"
        (click)="select(option)">
        @if (option.imgSrc) {
          <img [src]="option.imgSrc" [alt]="option.label" class="icon-dd-item__img">
        } @else if (option.icon) {
          <mat-icon class="material-symbols-outlined">{{ option.icon }}</mat-icon>
        }
        <span class="icon-dd-item__label">{{ option.label }}</span>
        @if (activeValue() === option.value) {
          <!-- wrapped in a span so mat-menu-item doesn't project it into the leading icon slot -->
          <span class="icon-dd-item__check-wrap">
            <mat-icon class="icon-dd-item__check">check</mat-icon>
          </span>
        }
      </button>
    }
  </ng-template>
</mat-menu>
